import { UiCard } from '@/ui/UiCard'
import { UiSkeleton } from '@/ui/UiSkeleton'

export default function ProposalCardSkeleton() {
  return (
    <UiCard>
      <div className='flex flex-wrap items-center gap-3 p-6'>
        <div className='order-1 min-w-0'>
          <UiSkeleton className='h-5 w-32' />
        </div>

        <div className='order-2 ml-auto shrink-0 sm:order-3'>
          <UiSkeleton className='h-7 w-24 rounded-full' />
        </div>

        <div className='order-3 w-full sm:order-2 sm:flex sm:flex-1 sm:justify-center'>
          <div className='flex flex-wrap items-start gap-x-10 gap-y-3'>
            <div className='flex min-w-40 flex-col gap-2'>
              <UiSkeleton className='h-3 w-28' />
              <UiSkeleton className='h-4 w-20' />
            </div>
            <div className='flex min-w-30 flex-col gap-2'>
              <UiSkeleton className='h-3 w-20' />
              <UiSkeleton className='h-4 w-14' />
            </div>
            <div className='flex min-w-30 flex-col gap-2'>
              <UiSkeleton className='h-3 w-10' />
              <UiSkeleton className='h-4 w-12' />
            </div>
            <div className='flex min-w-30 flex-col gap-2'>
              <UiSkeleton className='h-3 w-10' />
              <UiSkeleton className='h-4 w-12' />
            </div>
          </div>
        </div>
      </div>
    </UiCard>
  )
}
